/**
 * @namespace Teaser
 * @aka Planet.Teaser
 *
 */

Planet.Teaser = (function ($) {
  const NAME = 'teaser';
  const DATA_KEY = 'planet.' + NAME;
  const EVENT_KEY = '.' + DATA_KEY;
  const DATA_API_KEY = '.data-api';
  const JQUERY_NO_CONFLICT = $.fn[NAME];

  const Event = {
    PJAX_DATA_API: 'pjax:end' + EVENT_KEY + DATA_API_KEY
  };

  const Selector = {
    DATA_SPY: `
      .teaser,
      .teaser.media-audio,
      .teaser.media-video,
      .teaser.media-gallery,
      .teaser.media-imagegallery,
      .teaser.media-podcast,
      .teaser.media-liveblog
    `
  };

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */
  const Teaser = function () {

    function Teaser(element) {
      const self = this;

      // protected
      self.element = element;
      self.$element = $(self.element);

      self._addMediaIcon();

      if (window.isFractal || window.location.host.match(/localhost|beta[0-9]|standby|live-origin|vorschau/)) {
        //Um in den Entwicklertools ein bestimmtes Media-Icon auszuprobieren und
        //den Klassennamen ins HTML zu schreiben, braucht es den Observer,
        //der nach Änderung erneut die Funktion _addMediaIcon aufruft und
        //somit das neue Icon ins HTML rendert.
        var observer = new MutationObserver(function (mutationList, observer) {
          for (const mutation of mutationList) {
            if (mutation.attributeName === "class") {
              self._addMediaIcon();
            }
          }
        });

        observer.observe(self.$element[0], {attributes: true, childList: true, subtree: true});
      }
    }

    Teaser.prototype._addMediaIcon = function _addMediaIcon() {
      const self = this;
      const classList = self.$element.attr('class').split(" ");
      var media = "";
      const regex = new RegExp(/(media-audio)|(media-video)|(media-gallery)|(media-imagegallery)|(media-podcast)|(media-liveblog)/g);

      for (var i = 0; i < classList.length; i++) {
        if (regex.test(classList[i])) {
          media = classList[i];
          break;
        }
      }

      // Aus dem Backend gelieferte Media Icons entfernen.
      // Kann entfernt werden, wenn das Media Icon aus den Templates entfernt wird.
      self.$element.find('.media-icon-cnt').remove();

      //Entfernt für die Funktion des Hinzufügens einer Klasse/Änderns einer Klasse
      //das bisherige gesetzte Media-Icon.
      self.$element.find('.media-icon-container').remove();

      if(self.$element.hasClass('teaser-special')) {
        //Special-Teaser sollen kein Media-Icon haben
        return;
      }

      if (media) {
        const topline = self.$element.find('.topline').text();
        const headline = self.$element.find('.headline').text();
        const title = [topline, headline].filter(Boolean).join(' - ');
        const url = self.$element.find('a').attr('href');
        const mediaIconClass = media.replace('media', 'media-icon')
        const icon = media.replace('media-', '')
        const mediaIconElem = `
          <div class="media-icon-container">
            <a href="${url}" title="${title}">
              <span class="${mediaIconClass}">
                ${Planet.Util.svgIcon(icon)}
              </span>
            </a>
          </div>`;

        if (media === 'media-liveblog') {
          self.$element.find('.hgroup').before(mediaIconElem);
        } else {
          self.$element.find('.hgroup').after(mediaIconElem);
        }
      }
    }

    // public
    Teaser.prototype.dispose = function dispose() {
      this.$element.off(EVENT_KEY);

      this.$element = null;
      this.element = null;

      $(document).off(EVENT_KEY);
    };

    // static
    Teaser._jQueryInterface = function _jQueryInterface() {
      return this.each(function () {
        let data = $(this).data(DATA_KEY);

        if (!data) {
          data = new Teaser(this);
          $(this).data(DATA_KEY, data);
        }
      });
    };

    return Teaser;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */
  $(Selector.DATA_SPY).each(function () {
    const $element = $(this);
    Teaser._jQueryInterface.call($element, $element.data());
  });

  $(document).on(Event.PJAX_DATA_API, function (event, xhr, options) {
    $(options.container).find(Selector.DATA_SPY).each(function () {
      const $element = $(this);
      Teaser._jQueryInterface.call($element, $element.data());
    });
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */
  $.fn[NAME] = Teaser._jQueryInterface;
  $.fn[NAME].Constructor = Teaser;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Teaser._jQueryInterface;
  };

  return Teaser;

})(window.jQuery);
